import { defineFetch } from 'resift';

const makeUpdateRole = defineFetch({
  displayName: 'Update Role',
  make: (personId: string, key?: string) => ({
    request: (role: number) => ({ http }) =>
      http({
        method: 'PUT',
        route: `/people/${personId}/role`,
        data: {
          role,
        },
      }),
  }),
});

export default makeUpdateRole;
